import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import fileDownload from 'js-file-download';
import store from '@/state/store';
import { adsAPI, affiliateAPI } from '@samclick-static-urls';
import { sendGet, sendPut, sendPost } from '@samclick-api-client';
import Payload from './payload';
import { multipleReplace } from '@/utils/common-utils';
import { affiliateAPI as affiliateUAAPI } from "@/api-client/static-url-ua";
import { sendUAGet } from '@/api-client/unified-api';


class AdvertisementsState {
    public loading: boolean = false

    public ads: object[] = []

    public campaignList: object[] = []

    public adsList: object[] = []

    public landingPages: object[] = []

    public adsStats: object[] = []

    public adsTotal: number = 0
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'advertisements',
})
class AdvertisementsStore extends VuexModule {
    advertisementsStore: AdvertisementsState = new AdvertisementsState();

    @Mutation
    ADVERTISEMENTS_REINITIALIZE() {
        this.advertisementsStore = new AdvertisementsState();
    }

    @Mutation
    SET_ADVERTISEMENTS_LOADING(loading: boolean) {
        this.advertisementsStore.loading = loading;
    }

    @Action({ rawError: true })
    showLoader(show: boolean) {
        this.context.commit('SET_ADVERTISEMENTS_LOADING', show);
    }

  @Mutation
    SET_ADS(response: object = {}) {
        this.advertisementsStore.ads = response.value || [];
        this.advertisementsStore.adsTotal = response.additional_info ? response.additional_info.totalCount : 0;
    }

  @Mutation
  SET_CAMPAIGN_LIST(response: object[]) {
      this.advertisementsStore.campaignList = response || [];
  }

  @Mutation
  SET_ADVERTISEMENT_LIST(response: object[]) {
      this.advertisementsStore.adsList = response || [];
  }

  @Mutation
  SET_LANDING_PAGE_LIST(response: object[]) {
      this.advertisementsStore.landingPages = response || [];
  }

  @Mutation
  SET_ADVERTISEMENT_STATS(response: object[]) {
      this.advertisementsStore.adsStats = response || {};
  }

    @Action({ rawError: true })
  destroyAdvertisements() {
      this.context.commit('ADVERTISEMENTS_REINITIALIZE');
  }

  @Action({ rawError: true })
    destroyAdvertisementsTable() {
        this.context.commit('SET_ADS', {});
    }

  @Action({ rawError: true })
  getAdsList(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(adsAPI.getAds, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_ADS', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getAdvertismentList(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(adsAPI.getAdsList, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_ADVERTISEMENT_LIST', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getCampaignList(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(adsAPI.campaignList, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_CAMPAIGN_LIST', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getAdsByID(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(multipleReplace(adsAPI.getAdsByID, { '#adsID': payload.data.adsID }), {}, true).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getLandingPageList(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(adsAPI.getLandingPages, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_LANDING_PAGE_LIST', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getLandingPageByID(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(multipleReplace(adsAPI.getLandingPageByID, { '#landingPageID': payload.data.landingPageID }), {}, true).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  saveClick(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendPost(multipleReplace(adsAPI.saveClick, { '#adsID': payload.data.advertisementID }), payload.data, true).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  advertisementStats(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(adsAPI.getAdsStats, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_ADVERTISEMENT_STATS', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  exportMediaTraffic(payload: Payload = new Payload()) {
      this.showLoader(false);
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.exportMediaTrafficReports, payload.data).then((response) => {
              fileDownload(response.data, 'report-file.csv');
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }
}

export default getModule(AdvertisementsStore);
